import { useState, useEffect, useCallback } from "react";
import ServiceService from "../../../../services/service_service";
import { useTenant } from "../../../../hooks/useTenant";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export const useServices = () => {
    const { idTenant, user } = useTenant();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const fetchItems = useCallback(async () => {
        if (!idTenant) return;
        setLoading(true);
        try {
            const data = await ServiceService.getServices(idTenant);
            setItems(data);
        } catch (error) {
            console.error("Erro ao buscar serviços/produtos:", error);
            toast.error("Não foi possível carregar os serviços e produtos.");
        } finally {
            setLoading(false);
        }
    }, [idTenant]);

    useEffect(() => {
        fetchItems();
    }, [fetchItems]);

    const handleSave = async (formData, resetForm) => {
        setIsSaving(true);
        try {
            const savedItem = await ServiceService.save(formData, idTenant, user, items);
            toast.success("Salvo com sucesso!");
            if (!formData.id && resetForm) {
                resetForm();
            }
            await fetchItems();
            return savedItem;
        } catch (error) {
            console.error("Erro ao salvar:", error);
            toast.error("Erro ao salvar.");
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = async (itemId, itemName) => {
        Swal.fire({
            title: "Tem certeza?",
            text: `Deseja realmente excluir "${itemName}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#74788d",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await ServiceService.delete(itemId, idTenant, user, itemName);
                    toast.success("Excluído com sucesso!");
                    setItems(items.filter(i => i.id !== itemId));
                } catch (error) {
                    console.error("Erro ao excluir:", error);
                    toast.error("Erro ao excluir.");
                }
            }
        });
    };

    const handleReorder = async (newItems) => {
        setItems(newItems); // Atualiza UI imediatamente
        try {
            await ServiceService.reorder(newItems, idTenant, user);
        } catch (error) {
            console.error("Erro ao reordenar:", error);
            toast.error("Erro ao reordenar. Recarregando lista original.");
            fetchItems(); // rollback
        }
    };

    return {
        items,
        loading,
        isSaving,
        handleSave,
        handleDelete,
        handleReorder
    };
};
